import {Skeleton, SplitButtonSkeleton} from '@sollapay/ui/components';
import {useIsGuestSession} from '@sollapay/web-core';
import {Navigate, useParams} from 'react-router-dom';

import {PageContent, PageLayout} from '@/layouts';

import {
  ActivationCard,
  ActivationPackageListSkeleton,
  ActivationPageHeader,
  ActivationPageHeaderSection
} from '../features/trust-accounts/activation/components';
import {TrustAccountActivation} from '../features/trust-accounts/activation/containers';
import {useActivationViewModel} from '../features/trust-accounts/activation/hooks';
import {useShareButtonQueries} from '../features/trust-accounts/share';

import type {FC} from 'react';

export const TrustAccountActivationPage: FC = () => {
  const {id} = useParams<{id: string}>();
  const {
    isLoading,
    error,
    refetch,
    packages,
    canSendPackages,
    isActivationLocked,
    isTrustActive,
    trustAccount
  } = useActivationViewModel(id ?? '');
  // Started with the account, so the share button doesn't wait for it to load first.
  useShareButtonQueries(id ?? '');
  const isGuest = useIsGuestSession();

  if (isLoading || !trustAccount) {
    return (
      <PageLayout error={error} refetch={() => void refetch()}>
        <ActivationPageHeaderSection
          trustAccount={trustAccount}
          action={isGuest ? undefined : <SplitButtonSkeleton />}
        />
        <PageContent>
          <ActivationCard>
            <ActivationPageHeader />
            <ActivationPackageListSkeleton />
            <div className="px-8 pb-8">
              <Skeleton className="h-11 w-full rounded-md" />
            </div>
          </ActivationCard>
        </PageContent>
      </PageLayout>
    );
  }

  if (isTrustActive) {
    return <Navigate to={`/trust-accounts/${id}`} replace />;
  }

  return (
    <TrustAccountActivation
      trustAccount={trustAccount}
      packages={packages}
      canSendPackages={canSendPackages}
      isActivationLocked={isActivationLocked}
      isTrustActive={isTrustActive}
      error={error}
      refetch={() => void refetch()}
    />
  );
};
